import { get, post, put, del } from './api';

// Create a new branch
export const createBranch = (data) => {
  return post('/branches', data);
};

//  Get all brands as list (no pagination)
export const getAllBranchLists = () => {
  return get('/branches/list');
};

export const getAllBranches = (
  page = 1,
  limit = 10,
  search = '',
  sortField = 'id',    
  sortOrder = 'desc'   
) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (search) params.append('name', search);
  if (sortField) params.append('sort_field', sortField);
  if (sortOrder) params.append('sort_order', sortOrder);

  return get(`/branches?${params.toString()}`);
};

// Get a branch by ID
export const getBranchById = (id) => {
  return get(`/branches/${id}`);
};

// Update a branch
export const updateBranch = (id, data) => {
  return put(`/branches/${id}`, data);
};

// Delete a branch (soft delete if your backend supports it)
export const deleteBranch = (id) => {
  return del(`/branches/${id}`);
};
